import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

/**
 * Estado de ERRO de carga da Análise Econômica (DFP Histórica) e da Modelagem DFP.
 *
 * Existe para separar duas coisas que a tela antes confundia: "a empresa não tem documentos"
 * (`app-dfp-empty-state`) e "a carga falhou" (API fora, rede, 500). Falha de carga NUNCA vira estado vazio:
 * dizer "nenhum documento enviado" de uma empresa que tem documentos manda o usuário reenviar o que já existe.
 *
 * Visual irmão do `app-dfp-empty-state` (cartão centrado, ícone, título, texto e UM botão), com o ícone de alerta.
 * Se o backend mandou mensagem de negócio (`businessMessage`), ela aparece no lugar do texto padrão, porque já foi
 * escrita para o usuário. Mensagem técnica (`key: "Exception"`) não chega aqui: o texto padrão cobre.
 */
@Component({
  selector: 'app-dfp-load-error',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './dfp-load-error.component.html',
  styleUrls: ['./dfp-load-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DfpLoadErrorComponent {
  /** Título do cartão. */
  @Input() title = 'Não foi possível carregar a modelagem desta empresa agora.';

  /** Mensagem de negócio devolvida pelo backend; `null` usa o texto padrão. */
  @Input() businessMessage: string | null = null;

  /** O usuário pediu para tentar de novo: a tela refaz a carga. */
  @Output() retry = new EventEmitter<void>();
}
